import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractBinaryOperatorFormulaToken from "./AbstractBinaryOperatorFormulaToken.js";
import AdditionFormulaNode from "../formula/AdditionFormulaNode.js";

/**
 * Binary operation token representing a mathematical addition.
 */
export default class AdditionFormulaToken extends AbstractBinaryOperatorFormulaToken {
	accept(visitor) {
		return visitor.visitAdditionFormulaToken(this);
	}

	_formulaNodeConstructor() {
		return AdditionFormulaNode;
	}

	static getLabel() {
		return _("Addition");
	}

	static getType() {
		return "addition";
	}
}
